module.exports = __webpack_public_path__ + "static/wentor2-9d83f7b58968f30f54d0e8e267b929ec.png";